import {addParamToUrl, removeParamFromUrl} from "./utils/urlHelpers";
import {updateFilter} from "./utils/filterRequests";
import {dateFromString, formatDate} from "./utils/dateHelpers";
import {getCalendarTooltips, getLang, getLocale} from "./utils/localeUtils";
import {resetPricePerNightIfNotModified} from "./utils/filterUtils";
import {isTouchDevice} from "./utils/responsive";

const mainFilter = document.getElementById("main-filter");
const filterRegion = document.querySelectorAll('input[type=radio][name="region"]');
const filterRegionValue = document.getElementById("filter-value-region");
const filterRegionTrigger = document.getElementById("filter-region__trigger");
const filterRegionList = document.getElementById("filter-region__list");
const filterCapacityMode = document.getElementById("capacityMode");
const filterCapacity = document.getElementById("capacity");
const filterDates = document.getElementById('dates');
const filterCountries = document.querySelectorAll(".country-filter-item");
const isFilter = document.body.classList.contains('app_filter');
var capacityChangedTimeout;

//User changed value of dates filter
filterDates.addEventListener("change", filterDatesChangeHandler);

const touchDevice = isTouchDevice();

filterRegionTrigger.addEventListener(touchDevice ? "click" : "mouseover", function (e) {

    let width = window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;

    //remove disabled attribute from input
    //filterRegionValue.removeAttribute("disabled");

    // Ignore input focus on first time click for mobile devices
    if (touchDevice) {
        if (!e.target.closest('#region').querySelector('#filter-region__list').classList.contains('active')) {
            e.target.blur();
        }
    }

    filterRegionList.classList.add("active");

    if (width > 992) {
        const parent = document.getElementById("main-filter__section--region");
        filterRegionList.style.width = parent.offsetWidth + "px";
    }
});

filterRegionTrigger.addEventListener("click", function (e) {
    if (localStorage.getItem("filterRegionId")) {
        filterRegionValue.value = "";
    }

    if (!localStorage.hasOwnProperty("filterCity")) {
        filterRegionValue.value = "";
    }
});

//user typed into location field
filterRegionValue.addEventListener("change", regionValueChangeHandler);
filterRegionValue.addEventListener("keydown", locationValueKeydown);

//Also used id reservation-new.js
var dates;

function initLitepicker() {
    if (typeof (Litepicker) !== "undefined") {
        const locale = getLocale();

        dates = new Litepicker({
            element: filterDates,
            singleMode: false,
            numberOfMonths: 2,
            numberOfColumns: 2,
            hotelMode: true,
            minDate: new Date(),
            allowRepick: true,
            useResetBtn: true,
            format: "D. M. YYYY",
            tooltipNights: true,
            autoRefresh: true,
            footer: "<div class='date-picker-footer'></div>",
            lang: getLang(locale),
            minDays: 2,
            tooltipText: getCalendarTooltips(locale),
            buttonText: {
                prev: '<i class="fas fa-angle-left"></i>',
                next: '<i class="fas fa-angle-right"></i>',
                close: '×',
                reset: 'Reset',
                apply: 'Apply'
            },
            resetBtnCallback: function () {
                localStorage.removeItem("filterDateFrom");
                localStorage.removeItem("filterDateTo");
                removeParamFromUrl("dates");
                if (isFilter) {
                    removeParamFromUrl("p");
                    updateFilter();
                }

                dates.hide();
            },
            onShow: function () {
                let footer = $(".litepicker");

                if (footer.length > 0) {
                    $.ajax({
                        url: "/editable-string/informace-k-terminum-filtr",
                        method: "GET",
                        success: function (r) {
                            footer.css("width", $(".litepicker").css("width"));

                            footer.append("<div class='litepicker-footer'>" + r + "</div>");
                        }
                    })
                }
            },
            onSelect: function (date1, date2) {
                if (date1) {
                    //console.log(formatDate(date1, "."));
                }

                if (date2) {
                    let formattedDate1 = formatDate(date1, "-");
                    let formattedDate2 = formatDate(date2, "-");

                    if (formattedDate1 && formattedDate2) {
                        localStorage.setItem('filterDateFrom', formattedDate1);
                        localStorage.setItem('filterDateTo', formattedDate2);
                    }

                    if (isFilter && formattedDate1 && formattedDate2) {
                        if (localStorage.hasOwnProperty("filterDatesFromStorage")) {
                            //console.log("refreshing dates");
                            updateFilter(false);
                            addParamToUrl("dates", formattedDate1 + " - " + formattedDate2, false);
                            localStorage.removeItem("filterDatesFromStorage");
                        } else {
                            //console.log("selected dates");
                            removeParamFromUrl("p");
                            updateFilter();
                            addParamToUrl("dates", formattedDate1 + " - " + formattedDate2);
                        }
                    }
                }
            }
        });
    }
}

initLitepicker();

if (localStorage.getItem("filterDateFrom") && localStorage.getItem("filterDateTo")) {
    let dateFrom = dateFromString(localStorage.getItem("filterDateFrom"));
    let dateTo = dateFromString(localStorage.getItem("filterDateTo"));

    if (dateFrom instanceof Date && !isNaN(dateFrom) && dateTo instanceof Date && !isNaN(dateTo)) {
        localStorage.setItem("filterDatesFromStorage", "true");
        dates.setDateRange(dateFrom, dateTo);
    } else {
        removeParamFromUrl("dates");
        //console.log("not valid dates");
    }
}

if (localStorage.getItem("filterRegionName")) {
    filterRegionValue.value = localStorage.getItem("filterRegionName");
} else if (localStorage.getItem("filterCountryName")) {
    filterRegionValue.value = localStorage.getItem("filterCountryName");
} else if (localStorage.getItem("filterCity")) {
    filterRegionValue.value = localStorage.getItem("filterCity");
} else {
    filterRegionValue.value = "";
}

if (localStorage.getItem("filterRegionId")) {
    let regionId = parseInt(localStorage.getItem("filterRegionId"));
    if (regionId) {
        let regionRadioButton = document.querySelector('input[type=radio][name="region"][value="' + regionId + '"]');
        if (regionRadioButton) {
            regionRadioButton.checked = true;
        }
    }
}

if (localStorage.getItem("filterCountryId")) {
    let countryId = parseInt(localStorage.getItem("filterCountryId"));
    if (countryId) {
        let countryRadionButton = document.querySelector('input[type=radio][name="country"][value="' + countryId + '"]');
        if (countryRadionButton) {
            countryRadionButton.checked = true;
        }
    }
}

if (localStorage.getItem("filterCapacityMode")) {
    filterCapacityMode.value = localStorage.getItem("filterCapacityMode");
    //console.log("val " + filterCapacityMode.value);
} else {
    //console.log("reset capacity mode to min");
    localStorage.setItem("filterCapacityMode", "min");
}

if (localStorage.getItem("filterCapacity")) {
    filterCapacity.value = localStorage.getItem("filterCapacity");
}

Array.prototype.forEach.call(filterRegion, function (radio) {
    radio.addEventListener('click', regionChangeHandler);
});

Array.prototype.forEach.call(filterCountries, function (radio) {
    radio.addEventListener('click', countryChangeHandler);
});

filterCapacityMode.addEventListener("change", function () {
    if (isFilter) {
        addParamToUrl("capacityMode", this.value);
    }

    localStorage.setItem('filterCapacityMode', this.value);
    if (isFilter) {
        removeParamFromUrl("p");
        updateFilter();
    }
});

filterCapacity.addEventListener("change", function () {
    capacityChangeHandler(this.value)
});

function filterDatesChangeHandler() {
    if (this.value.length < 1) {
        localStorage.removeItem("filterDateFrom");
        localStorage.removeItem("filterDateTo");
        removeParamFromUrl("dates");
    }
}

function scrollToFilter() {
    const filter = document.getElementById("main-filter");
    if (filter) {
        if (filter.getBoundingClientRect().top < 0) {
            filter.scrollIntoView({behavior: "smooth"});
        }
    }
}

function regionChangeHandler() {
    filterRegionList.classList.remove("active");

    //font weight
    filterRegionValue.style.fontWeight = "bold";

    scrollToFilter();

    localStorage.removeItem("filterCountryId");
    localStorage.removeItem("filterCountryName");
    localStorage.removeItem("filterCity");

    resetPricePerNightIfNotModified();

    let id = this.value;

    if (!id) {
        id = "placeholder";
    }

    let name = document.querySelectorAll('label[for=region_' + id + ']')[0].innerHTML;
    filterRegionValue.value = name;

    if (id === "placeholder") {
        localStorage.removeItem("filterRegionId");
        localStorage.removeItem("filterRegionName");
        localStorage.removeItem("filterCountryId");
        localStorage.removeItem("filterCountryName");
        removeParamFromUrl("region");
        removeParamFromUrl("country");
    } else {
        localStorage.setItem('filterRegionId', id);
        localStorage.setItem('filterRegionName', name);

        if (isFilter) {
            addParamToUrl("region", id);
        }
    }

    removeParamFromUrl("location");
    removeParamFromUrl("country");

    if (isFilter) {
        removeParamFromUrl("p");
        updateFilter();
    }
}

function countryChangeHandler() {
    filterRegionList.classList.remove("active");

    //font weight
    filterRegionValue.style.fontWeight = "bold";

    scrollToFilter();

    localStorage.removeItem("filterRegionId");
    localStorage.removeItem("filterRegionName");
    localStorage.removeItem("filterCity");

    resetPricePerNightIfNotModified();

    let id = this.dataset.id;

    if (!id) {
        return;
    }

    let name = this.innerHTML;

    filterRegionValue.value = name;

    localStorage.setItem('filterCountryId', id);
    localStorage.setItem('filterCountryName', name);

    if (isFilter) {
        addParamToUrl("country", id);
    }

    removeParamFromUrl("location");
    removeParamFromUrl("region");
    if (isFilter) {
        updateFilter();
    }
}

function locationValueKeydown(e) {
    localStorage.setItem("filterCity", this.value);
    localStorage.removeItem("filterRegionId");
    localStorage.removeItem("filterRegionName");
    localStorage.removeItem("filterCountryId");
    localStorage.removeItem("filterCountryName");
    removeParamFromUrl("region");
    removeParamFromUrl("country");

    //remove region and country from form values
    Array.prototype.forEach.call(filterRegion, function (radio) {
        radio.checked = false;
    });

    Array.prototype.forEach.call(filterCountries, function (radio) {
        radio.checked = false;
    });

    if (e.keyCode === 13 || this.value.length > 0) {  //checks whether the pressed key is "Enter"
        filterRegionList.classList.remove("active");
    }

    if (this.value.length > 0) {
        //font weight
        filterRegionValue.style.fontWeight = "normal";
    }
}

function regionValueChangeHandler(e) {
    //User typed into search field
    if (this.value.length) {
        if (isFilter) {
            addParamToUrl("location", this.value);
        }
    } else {
        removeParamFromUrl("location");
    }

    if (isFilter) {
        updateFilter();
    }
}

function capacityChangeHandler(newValue) {
    clearTimeout(capacityChangedTimeout);

    capacityChangedTimeout = setTimeout(function () {
        if (isFilter) {
            addParamToUrl("capacity", newValue);
        }

        localStorage.setItem('filterCapacity', newValue);

        if (isFilter) {
            removeParamFromUrl("p");
            updateFilter();
        }
    }, 200);
}

//Capacity counter
$(function () {
    const filterCapacity = $("#capacity");

    $(document).on('click', '.filter-capacity--plus', function () {
        filterCapacity.val(parseInt(filterCapacity.val()) + 1).change();
        capacityChangeHandler(filterCapacity.val());
    });

    $(document).on('click', '.filter-capacity--minus', function () {
        filterCapacity.val(parseInt(filterCapacity.val()) - 1).change();
        if (filterCapacity.val() === 0) {
            filterCapacity.val(1);
        }
        capacityChangeHandler(filterCapacity.val());
    });

    $.ajax({
        url: "/api/season/disabled-dates",
        method: "GET",
        success: function (r) {
            let disabledDates = [];

            r.forEach(function (item) {
                disabledDates.push(new Date(item));
            });

            if (typeof (Litepicker) !== "undefined") {
                dates.setLockDays(disabledDates);
            }
        }
    });
});

mainFilter.classList.add("loaded");

//Hide region list when clicked outside
$(document).click(function (event) {
    if (!$(event.target).closest("#region").length) {
        $("body").find("#filter-region__list").removeClass("active");
    }
});